// extracted by mini-css-extract-plugin
export default {"center":"Subtitle_center__bztQ+","subtitleText":"Subtitle_subtitleText__vexRo","newLine":"Subtitle_newLine__Tmj17"};